import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { get } from 'lodash';

import {
  newNextAction,
  NEW_NEXT,
} from '../../actions/navigation';
import { useConfig } from '../../config/ConfigContext';
import Header from '../../components/Header';
import imgDocusign from '../../assets/images/docusign.png';

const VerifyID = (props) => {
  const config = useConfig();
  const { navigate, checkinData, params, searchParams } = props;

  useEffect(() => {
    const workflowType = get(params, 'workflowType');

    if (get(checkinData, ['data', 'data']) === undefined) {
      navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${searchParams.get('key')}`);
    }
  }, []);

  useEffect(() => {
    const { fetch } = props;
    if (fetch.isDone[`${NEW_NEXT}`] && !fetch.isRunning[`${NEW_NEXT}`]) {
      const routeUrl = checkinData.data && checkinData.data.url.replace(config.hostUrl, '');
      navigate(`${routeUrl}`);
    }
  }, [checkinData]);

  const handleButtonClick = () => {
    const { dispatch } = props;
    const workflowType = get(params, 'workflowType') || 'text2apply';

    dispatch(newNextAction({
      key: searchParams.get('key'),
      workflowType,
    }));
  };

  return (
    <div className="transition-item wrapper agreement verify-id">
      <Header />
      <Link to="/agreement/definitions" className="btn btn-sm header-btn">Definitions</Link>
      <div className="content">
        <div className="docusign-header">
          <img src={imgDocusign} alt="" />
          <h1>ID Check Questions</h1>
          <p>These questions are being generated as a means of an identity check by the document sender. None of this information is provided to the document sender or anyone else but you.</p>
        </div>

        <div className="container">
          <div className="row">
            <div className="col">

              <div className="card full">
                <div className="card-header">
                  <div className="row">
                    <div className="col">
                      <h5>Which of the following addresses have you ever been associated with?</h5>
                    </div>
                  </div>
                </div>
                <div className="card-content">
                  <label className="form-check">
                    <div className="row">
                      <div className="col-auto">
                        <input type="checkbox" />
                      </div>
                      <div className="col">
                        93746 Jerico Road
                      </div>
                    </div>
                  </label>
                  <label className="form-check">
                    <div className="row">
                      <div className="col-auto">
                        <input type="checkbox" />
                      </div>
                      <div className="col">
                        9376 Callistoga Drive
                      </div>
                    </div>
                  </label>
                  <label className="form-check">
                    <div className="row">
                      <div className="col-auto">
                        <input type="checkbox" />
                      </div>
                      <div className="col">
                        504 North Green Street
                      </div>
                    </div>
                  </label>
                  <label className="form-check">
                    <div className="row">
                      <div className="col-auto">
                        <input type="checkbox" />
                      </div>
                      <div className="col">
                        1020 Lawrence Avenue
                      </div>
                    </div>
                  </label>
                  <label className="form-check">
                    <div className="row">
                      <div className="col-auto">
                        <input type="checkbox" />
                      </div>
                      <div className="col">
                        I’ve never been associated with any of these addresses
                      </div>
                    </div>
                  </label>
                </div>
              </div>

              <div className="card full">
                <div className="card-header">
                  <div className="row">
                    <div className="col">
                      <h5>Which of the following addresses have you ever been associated with?</h5>
                    </div>
                  </div>
                </div>
                <div className="card-content">
                  <label className="form-check">
                    <div className="row">
                      <div className="col-auto">
                        <input type="checkbox" />
                      </div>
                      <div className="col">93746 Jerico Road</div>
                    </div>
                  </label>
                  <label className="form-check">
                    <div className="row">
                      <div className="col-auto">
                        <input type="checkbox" />
                      </div>
                      <div className="col">
                        9376 Callistoga Drive
                      </div>
                    </div>
                  </label>
                  <label className="form-check">
                    <div className="row">
                      <div className="col-auto">
                        <input type="checkbox" />
                      </div>
                      <div className="col">
                        504 North Green Street
                      </div>
                    </div>
                  </label>
                  <label className="form-check">
                    <div className="row">
                      <div className="col-auto">
                        <input type="checkbox" />
                      </div>
                      <div className="col">
                        1020 Lawrence Avenue
                      </div>
                    </div>
                  </label>
                  <label className="form-check">
                    <div className="row">
                      <div className="col-auto">
                        <input type="checkbox" />
                      </div>
                      <div className="col">
                        I’ve never been associated with any of these addresses
                      </div>
                    </div>
                  </label>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="row">
          <div className="col">
            <button onClick={handleButtonClick} type="button" className="btn arrow">Submit</button>
          </div>
        </div>
      </div>
    </div>
  );
};

VerifyID.propTypes = {
  navigate: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  fetch: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(VerifyID);
